if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
				this.qvGallery = null;
				this.qvTimers = [];

				// Changement de variante (couleur) -> on affiche l'image de la variante dans la galerie
				if (this.modalContent) {
					this.modalContent.addEventListener("change", () => {
						setTimeout(() => this.syncGalleryWithVariant(), 0);
					});
				}

				// Navigation clavier dans la galerie
				this.addEventListener("keydown", (event) => {
					if (!this.qvGallery || !this.hasAttribute("open")) return;
					const tag = (event.target.tagName || "").toLowerCase();
					if (tag === "input" || tag === "textarea" || tag === "select") return;
					if (event.key === "ArrowRight") this.qvGallery.next();
					if (event.key === "ArrowLeft") this.qvGallery.prev();
				});
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

				this.qvTimers.forEach((t) => clearInterval(t));
				this.qvTimers = [];
				this.qvGallery = null;

				this.modalContent.innerHTML = "";
				this.modalContent.classList.remove("qv-scope");

				$(".js-media-list").each(function () {
					if (this.swiper) this.swiper.destroy();
				});
				$(".js-media-sublist").each(function () {
					if (this.swiper) this.swiper.destroy();
				});

				subSliderInit(true);
				sliderInit(true);

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				const productUrl = opener.getAttribute("data-product-url");

				fetch(productUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.sectionId = this.productElement.dataset.section;

						// Styles de la page produit déclarés hors de la <section> (prix, bandeau promo, réassurance…)
						const externalStyles = this.collectSectionStyles();

						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener
						);

						this.modalContent.classList.add("qv-scope");
						this.injectSectionStyles(externalStyles);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						this.buildGallery();
						this.initPromoCountdown();
						this.addFullDetailsLink(productUrl);
						super.show(opener);
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						subSliderInit();
						sliderInit();

						/* Toggle fields */
						$(".js-show-more").click(function (e) {
							e.preventDefault();
							$(this).siblings("input").removeClass("hidden");
							$(this).siblings("label").removeClass("hidden");
							$(this).remove();
						});

						if (this.qvGallery) this.qvGallery.refresh();
					});
			}

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});
			}

			/* ------------------------------------------------------------------
			   Styles : on récupère les <style> et feuilles CSS de la section
			   produit pour que l'aperçu ait le même rendu que la page complète.
			------------------------------------------------------------------ */
			collectSectionStyles() {
				const wrapper =
					this.productElement.closest(".shopify-section") ||
					this.productElement.parentElement;
				const result = { css: [], links: [] };
				if (!wrapper) return result;

				wrapper.querySelectorAll("style").forEach((style) => {
					if (style.closest("noscript")) return;
					if (this.productElement.contains(style)) return;
					result.css.push(style.textContent);
				});

				wrapper.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
					if (link.closest("noscript")) return;
					const href = link.getAttribute("href");
					if (href) result.links.push(href);
				});

				return result;
			}

			scopeCss(css) {
				const sid = (this.sectionId || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
				if (!sid) return css;
				return css
					.replace(new RegExp(`#MainProduct-(?:quickadd-)?${sid}`, "g"), ".qv-scope")
					.replace(
						new RegExp(`\\.section-(?:quickadd-)?${sid}-padding`, "g"),
						".qv-scope"
					);
			}

			injectSectionStyles(external) {
				// Styles déjà présents dans la section : on remplace l'ID de section par le scope de l'aperçu
				this.modalContent.querySelectorAll("style").forEach((style) => {
					style.textContent = this.scopeCss(style.textContent);
				});

				const loaded = Array.from(
					document.querySelectorAll('link[rel="stylesheet"]')
				).map((l) => (l.getAttribute("href") || "").split("?")[0]);

				external.links.forEach((href) => {
					if (loaded.includes(href.split("?")[0])) return;
					const link = document.createElement("link");
					link.rel = "stylesheet";
					link.href = href;
					this.modalContent.prepend(link);
				});

				if (external.css.length) {
					const style = document.createElement("style");
					style.setAttribute("data-qv-styles", "");
					style.textContent = this.scopeCss(external.css.join("\n"));
					this.modalContent.prepend(style);
				}
			}

			/* ------------------------------------------------------------------
			   Galerie de l'aperçu : grande image + flèches + miniatures
			------------------------------------------------------------------ */
			getBestSrc(img) {
				const srcset = img.getAttribute("srcset") || img.getAttribute("data-srcset");
				if (srcset) {
					let best = null;
					let bestW = 0;
					srcset.split(",").forEach((part) => {
						const bits = part.trim().split(/\s+/);
						const w = parseInt(bits[1], 10) || 0;
						if (bits[0] && w >= bestW) {
							bestW = w;
							best = bits[0];
						}
					});
					if (best) return best;
				}
				return img.getAttribute("src") || img.getAttribute("data-src") || "";
			}

			withWidth(url, width) {
				try {
					const u = new URL(url, window.location.origin);
					u.searchParams.set("width", width);
					return u.toString();
				} catch (e) {
					return url;
				}
			}

			buildGallery() {
				const wrapper = this.modalContent.querySelector(".product__media-wrapper");
				if (!wrapper) return;

				let items = wrapper.querySelectorAll(
					".product-media-collage__content .product__media-item"
				);
				if (!items.length) {
					const list = wrapper.querySelector(".js-media-list");
					items = list ? list.querySelectorAll(".product__media-item") : [];
				}

				const slides = [];
				const seen = new Set();
				items.forEach((item) => {
					const img = item.querySelector("img");
					if (!img) return;
					const src = this.getBestSrc(img);
					if (!src) return;
					const key = src.split("?")[0];
					if (seen.has(key)) return;
					seen.add(key);
					slides.push({
						src: this.withWidth(src, 1400),
						thumb: this.withWidth(src, 240),
						alt: img.getAttribute("alt") || "",
						mediaId: (item.getAttribute("data-media-id") || "").split("-").pop(),
					});
				});

				if (!slides.length) return;

				const arrowLeft =
					'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
				const arrowRight =
					'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

				const gallery = document.createElement("div");
				gallery.className = "qv-gallery" + (slides.length < 2 ? " qv-gallery--single" : "");
				gallery.innerHTML = `
					<div class="qv-gallery__stage">
						<div class="qv-gallery__track" tabindex="0" aria-label="${((window.AH_I18N && window.AH_I18N.qa_gallery) || "Galerie produit")}">
							${slides
								.map(
									(s, i) => `
								<figure class="qv-gallery__slide" data-index="${i}">
									<img src="${s.src}" alt="${s.alt.replace(/"/g, "&quot;")}" ${i === 0 ? 'fetchpriority="high"' : 'loading="lazy"'} draggable="false">
								</figure>`
								)
								.join("")}
						</div>
						<button type="button" class="qv-gallery__nav qv-gallery__nav--prev" aria-label="${((window.AH_I18N && window.AH_I18N.qa_prev_image) || "Image précédente")}">${arrowLeft}</button>
						<button type="button" class="qv-gallery__nav qv-gallery__nav--next" aria-label="${((window.AH_I18N && window.AH_I18N.qa_next_image) || "Image suivante")}">${arrowRight}</button>
						<span class="qv-gallery__counter"><span data-qv-current>1</span> / ${slides.length}</span>
					</div>
					<div class="qv-gallery__thumbs" role="list">
						${slides
							.map(
								(s, i) => `
							<button type="button" class="qv-gallery__thumb${i === 0 ? " is-active" : ""}" data-index="${i}" aria-label="${((window.AH_I18N && window.AH_I18N.qa_view_image) || "Voir l'image {n}").replace("{n}", i + 1)}" role="listitem">
								<img src="${s.thumb}" alt="" loading="lazy" draggable="false">
							</button>`
							)
							.join("")}
					</div>`;

				wrapper.parentNode.insertBefore(gallery, wrapper);
				wrapper.classList.add("qv-original-media");

				const track = gallery.querySelector(".qv-gallery__track");
				const thumbsBox = gallery.querySelector(".qv-gallery__thumbs");
				const thumbs = Array.from(gallery.querySelectorAll(".qv-gallery__thumb"));
				const prevBtn = gallery.querySelector(".qv-gallery__nav--prev");
				const nextBtn = gallery.querySelector(".qv-gallery__nav--next");
				const current = gallery.querySelector("[data-qv-current]");
				let index = 0;

				const setActive = (i) => {
					index = i;
					current.textContent = i + 1;
					prevBtn.disabled = i <= 0;
					nextBtn.disabled = i >= slides.length - 1;
					thumbs.forEach((t, n) => t.classList.toggle("is-active", n === i));
					const active = thumbs[i];
					if (active) {
						const left =
							active.offsetLeft - thumbsBox.clientWidth / 2 + active.clientWidth / 2;
						thumbsBox.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
					}
				};

				const goTo = (i, smooth = true) => {
					const target = Math.max(0, Math.min(slides.length - 1, i));
					track.scrollTo({
						left: target * track.clientWidth,
						behavior: smooth ? "smooth" : "auto",
					});
					setActive(target);
				};

				let scrollTimer;
				track.addEventListener(
					"scroll",
					() => {
						clearTimeout(scrollTimer);
						scrollTimer = setTimeout(() => {
							if (!track.clientWidth) return;
							const i = Math.round(track.scrollLeft / track.clientWidth);
							if (i !== index) setActive(i);
						}, 60);
					},
					{ passive: true }
				);

				prevBtn.addEventListener("click", () => goTo(index - 1));
				nextBtn.addEventListener("click", () => goTo(index + 1));
				thumbs.forEach((t) =>
					t.addEventListener("click", () => goTo(parseInt(t.dataset.index, 10)))
				);

				this.qvGallery = {
					slides,
					goTo,
					next: () => goTo(index + 1),
					prev: () => goTo(index - 1),
					refresh: () => goTo(index, false),
				};

				setActive(0);
				this.syncGalleryWithVariant(false);
			}

			syncGalleryWithVariant(smooth = true) {
				if (!this.qvGallery) return;
				const picker = this.modalContent.querySelector("variant-radios, variant-selects");
				if (!picker) return;

				let variant = picker.currentVariant;
				if (!variant) {
					const idInput = this.modalContent.querySelector(
						'form[id^="product-form-"] input[name="id"]'
					);
					const json = picker.querySelector('[type="application/json"]');
					if (idInput && json) {
						try {
							variant = JSON.parse(json.textContent).find(
								(v) => String(v.id) === String(idInput.value)
							);
						} catch (e) {}
					}
				}

				const mediaId = variant && variant.featured_media && variant.featured_media.id;
				if (!mediaId) return;
				const i = this.qvGallery.slides.findIndex(
					(s) => String(s.mediaId) === String(mediaId)
				);
				if (i > -1) this.qvGallery.goTo(i, smooth);
			}

			/* Compte à rebours du bandeau promo (le script de la page ne tourne pas dans l'aperçu) */
			initPromoCountdown() {
				this.modalContent.querySelectorAll(".ah-product-promo-countdown").forEach((el) => {
					const endValue = el.getAttribute("data-end-date");
					const expiredText = el.getAttribute("data-expired-text") || ((window.AH_I18N && window.AH_I18N.qa_offer_expired) || "Offre expirée");
					if (!endValue) {
						el.textContent = "";
						return;
					}
					const end = new Date(endValue).getTime();
					if (isNaN(end)) {
						el.textContent = "";
						return;
					}
					const tick = () => {
						const d = end - Date.now();
						if (d <= 0) {
							el.textContent = expiredText;
							return;
						}
						const days = Math.floor(d / 86400000);
						const h = Math.floor((d / 3600000) % 24);
						const m = Math.floor((d / 60000) % 60);
						const s = Math.floor((d / 1000) % 60);
						el.textContent =
							days > 0
								? ((window.AH_I18N && window.AH_I18N.qa_expires_days) || "Expire dans {days}j {h}h {m}m").replace("{days}", days).replace("{h}", h).replace("{m}", m)
								: ((window.AH_I18N && window.AH_I18N.qa_expires_hours) || "Expire dans {h}h {m}m {s}s").replace("{h}", h).replace("{m}", m).replace("{s}", s);
					};
					tick();
					this.qvTimers.push(setInterval(tick, 1000));
				});
			}

			addFullDetailsLink(url) {
				const container = this.modalContent.querySelector(".product__info-container");
				if (!container || !url) return;
				const link = document.createElement("a");
				link.className = "qv-full-link";
				link.href = url.split("?")[0];
				link.innerHTML =
					((window.AH_I18N && window.AH_I18N.qa_full_details) || 'Voir la fiche produit complète') + ' <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
				container.appendChild(link);
			}

			removeDOMElements() {
				const remove = (selector, all = false) => {
					const nodes = all
						? this.productElement.querySelectorAll(selector)
						: [this.productElement.querySelector(selector)];
					nodes.forEach((el) => el && el.remove());
				};

				remove("related-slider", true);
				remove(".promo-banner", true);
				remove('[data-block-handle="reviews"]');
				remove(".about");
				remove(".share-buttons");
				remove(".rating");
				remove("#shopify-product-reviews");
				remove(".product-tags");
				remove(".advantage-wrapper");
				remove(".note");
				remove("pickup-availability");
				remove("product-modal");
				remove("floated-form");
				remove(".customer");
				remove(".about-wrapper", true);
				remove(".inventory__title");
				remove(".product__text-icon");
				remove(".payment_methods-wrapper");
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				if (!product) return;
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}